<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-6">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="webhook.nome" disabled />
        </div>
        <div class="col-md-6">
          <label>URL</label>
          <input type="text" class="form-control" v-model="webhook.url" disabled />
        </div>

        <div class="col-md-3 mt-1">
          <br />
          <label
            class="btn btn-primary w-100"
            :class="{ disabled: !webhook.ativo }"
            style="cursor: pointer"
          >
            <input type="checkbox" class="d-none" v-model="webhook.ativo" disabled />
            Ativo
          </label>
        </div>

        <div class="col-md-12 mt-2">
          <h4>Eventos</h4>
        </div>
        <div class="col-md-3">
          <label
            class="btn btn-primary w-100"
            :class="{ disabled: !eventoSenhaGerada }"
            style="cursor: pointer"
          >
            <input type="checkbox" class="d-none" v-model="eventoSenhaGerada" disabled />
            Senha gerada
          </label>
        </div>
        <div class="col-md-3">
          <label
            class="btn btn-primary w-100"
            :class="{ disabled: !eventoMudancaSetor }"
            style="cursor: pointer"
          >
            <input type="checkbox" class="d-none" v-model="eventoMudancaSetor" disabled />
            Mudança de setor
          </label>
        </div>

        <div class="col-md-12 mt-2" v-if="(webhook.headers || []).length">
          <h4>Headers</h4>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(header, index) in webhook.headers" :key="index">
                <td>{{ header.key }}</td>
                <td>{{ header.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-12 mt-2">
          <h4>Histórico de envios</h4>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Data</th>
                <th>Senha</th>
                <th>Evento</th>
                <th>Status</th>
                <th>Situação</th>
                <th>Tentativa</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log.id">
                <td>{{ formatarData(log.created_at) }}</td>
                <td>{{ log.payload ? log.payload.senha : "" }}</td>
                <td>{{ log.evento }}</td>
                <td>{{ log.status_code || "-" }}</td>
                <td>
                  <span v-if="log.sucesso" class="badge badge-primary">Sucesso</span>
                  <span v-else class="badge badge-danger">Falha</span>
                  <button
                    class="btn btn-sm btn-outline-secondary ml-1"
                    title="Ver resposta"
                    @click="verResposta(log)"
                  >
                    <i class="fa fa-code"></i>
                  </button>
                </td>
                <td>{{ log.tentativa }}</td>
                <td>
                  <button
                    v-if="!log.sucesso"
                    class="btn btn-sm btn-outline-primary"
                    @click="reenviar(log.id)"
                  >
                    Reenviar
                  </button>
                </td>
              </tr>
              <tr v-if="!logs.length">
                <td colspan="7" class="text-center">Nenhum envio registrado ainda</td>
              </tr>
            </tbody>
          </table>
        </div>

        <b-modal
          id="modalRespostaWebhook"
          ref="modalRespostaWebhook"
          title="Resposta do parceiro"
          size="lg"
          hide-footer
        >
          <pre class="json-viewer" v-html="respostaFormatada"></pre>
        </b-modal>

        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/webhooks" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  name: "WebhookView",
  data() {
    return {
      loader: 0,
      webhook: {},
      logs: [],
      eventoSenhaGerada: false,
      eventoMudancaSetor: false,
      respostaFormatada: "",
    };
  },
  computed: {},
  methods: {
    verResposta: function (log) {
      const self = this;

      self.respostaFormatada = self.formatarJson(log.resposta);
      self.$refs.modalRespostaWebhook.show();
    },
    escapeHtml: function (texto) {
      return String(texto)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    formatarJson: function (texto) {
      const self = this;

      if (!texto) {
        return "<em>Sem resposta registrada</em>";
      }

      let json;

      try {
        json = JSON.parse(texto);
      } catch (e) {
        return self.escapeHtml(texto);
      }

      const escapado = self.escapeHtml(JSON.stringify(json, null, 2));

      return escapado.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
        function (match) {
          let cls = "json-number";
          if (/^"/.test(match)) {
            cls = /:$/.test(match) ? "json-key" : "json-string";
          } else if (/true|false/.test(match)) {
            cls = "json-boolean";
          } else if (/null/.test(match)) {
            cls = "json-null";
          }
          return '<span class="' + cls + '">' + match + "</span>";
        }
      );
    },
    getWebhook: function (id) {
      const self = this;
      const api = self.$store.state.api + "webhooks/" + id;

      axios
        .get(api)
        .then((response) => {
          self.webhook = response.data.data[0];
          self.eventoSenhaGerada = (self.webhook.eventos || []).includes(
            "senha_gerada"
          );
          self.eventoMudancaSetor = (self.webhook.eventos || []).includes(
            "mudanca_setor"
          );
          self.setLoader(30);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    formatarData: function (data) {
      if (!data) {
        return "";
      }

      const d = new Date(data.replace(" ", "T"));

      if (isNaN(d.getTime())) {
        return data;
      }

      const pad = function (n) {
        return String(n).padStart(2, "0");
      };

      return (
        pad(d.getDate()) +
        "/" +
        pad(d.getMonth() + 1) +
        "/" +
        d.getFullYear() +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    getLogs: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "webhook_logs?webhook_id=" +
        id +
        "&paginated=false&orderByDesc=id";

      axios
        .get(api)
        .then((response) => {
          self.logs = response.data.data;
          self.setLoader(20);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    reenviar: function (logId) {
      const self = this;
      const api =
        self.$store.state.api + "webhook_logs/" + logId + "/reenviar";

      self.$loading(true);

      axios
        .post(api)
        .then(() => {
          self.$message(
            "Sucesso",
            "Reenvio agendado, atualize a página em instantes para ver o resultado",
            "success"
          );
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.setLoader(50);
      self.getWebhook(id);
      self.getLogs(id);
    } else {
      self.setLoader(100);
    }
  },
  components: {
    BaseCrud,
  },
};
</script>
<style scoped>
.json-viewer {
  background: #1e1e1e;
  color: #d4d4d4;
  padding: 15px;
  border-radius: 5px;
  max-height: 60vh;
  overflow: auto;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
<style>
.json-viewer .json-key {
  color: #9cdcfe;
}
.json-viewer .json-string {
  color: #ce9178;
}
.json-viewer .json-number {
  color: #b5cea8;
}
.json-viewer .json-boolean {
  color: #569cd6;
}
.json-viewer .json-null {
  color: #569cd6;
}
</style>
